export enum PlanPeriod {
  Monthly = 1,
  Annual = 12,
}
